import styled from 'styled-components';

export const OrderShippingMethodContainer = styled.div``;

export const OrderShippingMethod = styled.div<{ isDisabled?: boolean | null }>`
  padding: 0px 15px;
  border-radius: 5px;
  border: ${({ isDisabled }) =>
    isDisabled
      ? '2px solid rgba(0,0,0,0.125)'
      : '2px solid rgba(32, 154, 214, 1)'};
  margin-top: 10px;
  display: flex;
  align-items: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 0;
  margin-top: 10px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    > * {
      width: 100%;
    }
  }
`;

export const Title = styled.div`
  font-size: 1rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.93);
`;

export const ShippingTitle = styled(Title)<{ isDisabled?: boolean | null }>`
  font-size: 1rem;
  font-weight: 500;
  color: ${({ isDisabled }) =>
    isDisabled ? 'rgba(0, 0, 0, 0.63)' : 'rgba(0, 0, 0, 0.93)'};
  margin-left: 10px;
`;

export const SubTitle = styled.div`
  font-size: 0.9rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.63);
  margin-top: 5px;
`;

export const ErrorSection = styled.div`
  color: red;
  margin-top: 5px;
`;

export const ReadOnlyOrderShippingMethod = styled.div`
  display: flex;
  align-items: center;
`;

export const ShippingPromotionName = styled.div`
  margin-left: 10px;
`;
